const RgCoreVersion = "16.0.0";

export { RgCoreVersion };
//# sourceMappingURL=core-version.js.map
